import type { CallBarInput } from '@/components/call-bar/call-bar-idle/call-bar-idle-input';
import type { ReactNode } from 'react';
import { createContext, useCallback, useContext, useState } from 'react';

interface CallBarContextType {
  input: CallBarInput | undefined;
  setInput: (input: CallBarInput | undefined) => void;
  clearInput: () => void;
}

export const CallBarContext = createContext<CallBarContextType | null>(null);

export function CallBarProvider({ children }: { children: ReactNode }) {
  const [input, setInputState] = useState<CallBarInput | undefined>(undefined);

  const setInput = useCallback((value: CallBarInput | undefined) => {
    setInputState(value);
  }, []);

  const clearInput = useCallback(() => {
    setInputState(undefined);
  }, []);

  return (
    <CallBarContext.Provider value={{ input, setInput, clearInput }}>
      {children}
    </CallBarContext.Provider>
  );
}

export function useCallBar() {
  const context = useContext(CallBarContext);
  if (!context) {
    throw new Error('useCallBar must be used within a CallBarProvider');
  }
  return context;
}
